class TogglePet extends HTMLElement {
    constructor() {
        super();
        this.boundHandlers = {
            toggleChange: this.handleToggleChange.bind(this),
            addToCartClick: this.handleAddToCartClick.bind(this)
        };
    }

    connectedCallback() {
        this.init();
    }

    disconnectedCallback() {
        this.cleanup();
    }

    init() {
        // Cache DOM elements
        this.toggle = document.getElementById('AddAdditionalPet');
        this.uploader = document.querySelector('uploadcare-wrapper[data-pet-uploader]');
        this.addToCartButton = document.getElementById('AddToCart');
        this.modal = document.getElementById('missing-pet-modal');

        this.additionalPetPrice = parseInt(this.dataset.additionalPetPrice);

        // Validate required elements
        if (!this.toggle) {
            console.error('[TogglePet] Required toggle element not found');
            return;
        }

        // Add event listeners with bound handlers
        this.toggle.addEventListener('change', this.boundHandlers.toggleChange);

        if (this.addToCartButton) {
            this.addToCartButton.addEventListener('click', this.boundHandlers.addToCartClick);
        }

        this.setupModalListeners();
    }

    cleanup() {
        // Remove all event listeners
        this.toggle?.removeEventListener('change', this.boundHandlers.toggleChange);
        this.addToCartButton?.removeEventListener('click', this.boundHandlers.addToCartClick);
    }

    setupModalListeners() {
        if (!this.modal) return;

        const uploadBtn = this.modal.querySelector('#upload-pet-btn');
        const disableBtn = this.modal.querySelector('#disable-pet-btn');

        if (uploadBtn) {
            uploadBtn.addEventListener('click', () => {
                this.modal.close();
                this.triggerPetUpload();
            });
        }

        if (disableBtn) {
            disableBtn.addEventListener('click', () => {
                this.modal.close();
                this.toggle.checked = false;
                this.handleToggleChange();
            });
        }
    }

    handleToggleChange() {
        if (this.toggle.checked) {
            this.showUploader();
        } else {
            this.hideUploader();
        }

        this.updateUploaderState();

        document.querySelector('.canvas-list__list .selected')?.click();
    }

    handleAddToCartClick(e) {
        if (this.isPetRequiredButMissing()) {
            e.preventDefault();
            e.stopPropagation();
            this.showMissingPetModal();
        }
    }

    isPetRequiredButMissing() {
        if (!this.toggle.checked) {
            return false; // Pet not required
        }

        // Check if any pet images have been uploaded
        const successEntries = this.uploader?.successEntries;

        return !successEntries || successEntries.length === 0;
    }

    showMissingPetModal() {
        if (this.modal) {
            this.modal.open();
        }
    }

    triggerPetUpload() {
        const uploadButton = this.uploader?.querySelector('[data-open-flow]');
        if (uploadButton) {
            uploadButton.click();
        }
    }

    showUploader() {
        if (this.uploader) {
            window.theme.priceAddition = this.additionalPetPrice;
            this.uploader.classList.remove('hidden');
        }
    }

    hideUploader() {
        if (this.uploader) {
            window.theme.priceAddition = 0;
            this.uploader.classList.add('hidden');
        }
    }

    updateUploaderState() {
        if (!this.uploader) return;

        this.uploader.disabled = !this.toggle.checked;
        this.uploader.render();
    }
}

customElements.define('toggle-pet', TogglePet);
